import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, FlameIcon } from '../icons/SalesIcons';
export function OutcomesSection() {
  const outcomes = ['Dominarás los fundamentos técnicos de la velería artesanal — sin confusión, sin ensayo y error ciego', 'Crearás más de 15 tipos diferentes de velas, desde aromáticas básicas hasta velas repostería que parecen postres reales', 'Aprenderás la fórmula exacta de porcentajes que separa las velas aficionadas de las profesionales', 'Elegirás el pabilo correcto siempre, gracias a nuestra tabla de referencia exclusiva', 'Resolverás los 7 errores más comunes antes de que ocurran — porque ya sabes por qué suceden', 'Tendrás todo lo necesario para vender: plantilla de costos, lista de proveedores y comunidad de apoyo', 'Obtendrás tu certificado de finalización que respalda tu formación'];
  return <section className="bg-[#FDF8F4] py-16 md:py-24" data-id="element-312">
      <div className="max-w-4xl mx-auto px-4" data-id="element-313">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-314">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-315">
            <FlameIcon size={40} className="text-[#9B2335]" data-id="element-316" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#5C4033]" data-id="element-317">
            Todo Lo Que Vas a Lograr
          </h2>
        </motion.div>

        {/* Outcomes List */}
        <div className="space-y-4" data-id="element-318">
          {outcomes.map((outcome, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-5 shadow-md border border-[#C4A882]/20 flex items-start gap-4" data-id="element-319">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#C4A882] to-[#9B2335] flex items-center justify-center flex-shrink-0" data-id="element-320">
                <CheckIcon size={18} className="text-white" data-id="element-321" />
              </div>
              <p className="text-lg text-[#2D2926] leading-relaxed" data-id="element-322">
                {outcome}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}